import { WorkflowLayout } from "src/models/workflowLayout";
import { createEntityModel } from "src/store/models/entity/_shared";

export const WorkflowLayoutEntityModel = createEntityModel<WorkflowLayout>();
